<template>
  <div class="page">
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="个人信息" name="first">
        <div class="top_box">
          <strong>账号信息</strong>
          <div style="padding-top:30px;">
            兼职号：
            <span style="padding-left:10px;">{{jzb_number}}</span>
          </div>
          <div class="sty">
            登录账号：
            <span style="padding-left:10px;">{{list.identity}}</span>
          </div>
          <div>
            创建时间：
            <span style="padding-left:10px;">{{list.created_at}}</span>
          </div>
          <div style="height:200px;"></div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="系统密码" name="second">
        <div class="content">
          <div style="height:20px;"></div>
          <div class="content_child">
            <p style="margin-bottom:40px;">修改进入系统密码</p>
            <div>
              <el-form :model="form" :label-position="labelPosition" label-width="80px" :rules="rules" ref="ruleForm">
                <el-form-item label="手机号" prop="phone">
                  <el-input style="width:300px;" v-model="form.phone" placeholder="  请输入手机号" disabled></el-input>
                </el-form-item>
                <el-form-item type="number" label="验证码" prop="code">
                  <el-input style="width:200px;margin-right:10px;" v-model="form.code" placeholder="  请输入验证码"></el-input>
                  <span class="btn" v-if="codeShow" @click="getcode">获取验证码</span>
                  <span v-if="!codeShow" style="color:#4C71DB;font-size:12px;">{{count}}秒后重试</span>
                </el-form-item>
                <el-form-item label="新密码" prop="pwd">
                  <el-input style="width:300px;" type="password" v-model="form.pwd" placeholder="  请输入六到十六位密码"></el-input>
                </el-form-item>
                <el-form-item label="确认密码" prop="password">
                  <el-input style="width:300px;" type="password" v-model="form.password" placeholder="  请再次输入"></el-input>
                </el-form-item>
              </el-form>
              <div class="updatebtn" @click="submitForm('ruleForm')">确认修改</div>
              <div style="height:100px;"></div>
            </div>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="支付密码" name="third">
        <updatepwd></updatepwd>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import {
  userinfo,
  syatempasswordset,
  paypasswordset,
  getgalleryForgot,
  mobilesms,
  exitlogin
} from "@/api/login/login";
import updatepwd from "./update-paypassword";
export default {
  data () {
    var validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入密码"));
      } else {
        if (this.form.password !== "") {
          this.$refs.ruleForm.validateField("password");
        }
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.form.pwd) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    return {
      userInfo:null,
      jzb_number: jzb_number.mobile,
      flagindex: 0,
      codeShow: true,
      count: 0,
      activeName: "first",
      list: {},
      labelPosition: "right",
      form: {
        phone: "",
        code: "",
        pwd: "",
        password: ""
      },
      rules: {
        code: [
          { required: true, message: "请输入验证码", trigger: "change" },
          {
            pattern: /^[0-9]*$/,
            message: "只能是数字",
            trigger: "blur"
          },
          { min: 5, max: 5, message: "五位验证码", trigger: "blur" }
        ],
        phone: [
          { required: true, message: "请输入手机号码", trigger: "blur" },
          {
            pattern: /^1([38][0-9]|4[579]|5[0-3,5-9]|6[6]|7[0135678]|9[89])\d{8}$/,
            message: "手机号码格式不对，请重新输入",
            trigger: "blur"
          }
        ],
        pwd: [
          { required: true, validator: validatePass, trigger: "change" },
          { min: 6, max: 16, message: "长度在 6 到 16 个字符", trigger: "blur" }
        ],
        password: [
          { required: true, validator: validatePass2, trigger: "change" }
        ]
      }
    };
  },
  created () {
    this.getmessage();
    this.userInfo= JSON.parse(localStorage.getItem('userInfo'));
  },
  mounted () { },
  methods: {
    //获取手机号
    getgalleryForgot () {
      getgalleryForgot().then(res => {
        this.form.phone = res.data;
      });
    },
    //获取验证码
    getcode () {
      if (this.form.phone != "") {
        let data = {
          mobile: this.form.phone,
          mobile_type: 6
        };
        mobilesms(data).then(res => {
          if (res.code == 200) {
            const TIME_COUNT = 60;
            if (!this.timer) {
              this.count = TIME_COUNT;
              this.codeShow = false;
              this.timer = setInterval(() => {
                if (this.count > 0 && this.count <= TIME_COUNT) {
                  this.count--;
                } else {
                  this.codeShow = true;
                  clearInterval(this.timer);
                  this.timer = null;
                }
              }, 1000);
            }
            this.$message({
              type: "success",
              message: res.msg
            });
          }
        });
      } else {
        this.$message({
          type: "warning",
          message: "请先输入手机号"
        });
      }
    },
    submitForm (formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          let data = {
            mobile: this.form.phone,
            mobile_code: this.form.code,
            password: this.form.pwd,
            newpassword: this.form.password
          };
          syatempasswordset(data).then(res => {
            if (res.code == 200) {
              exitlogin(data).then(res => {
                if (res.code == 200) {
                  this.$message.success("修改成功请重新登录");
                  //清除token
                  localStorage.removeItem("token");
                  //跳转
                  this.$router.push({ name: "login" });
                }
              });
              this.form = {};
            }
            if (res.data.code == 406) {
              this.$message({
                type: "error",
                message: "验证码不正确"
              });
            }
          });
        } else {
          return false;
        }
      });
    },
    getmessage () {
      userinfo().then(res => {
        this.list = res.data;
      });
    },
    handleClick (tab, event) {
      if (tab.index == 0) {
        this.getmessage();
      }
      if (tab.index == 1) {
        this.getgalleryForgot();
      }
    }
  },
  components: {
    updatepwd
  }
};
</script>

<style lang='scss' scoped>
.page {
  .content {
    .content_child {
      border-radius: 8px;
      background-color: white;
      padding-top: 30px;
      padding-left: 25px;
      .updatebtn {
        width: 120px;
        height: 40px;
        background-color: #4c71db;
        border-radius: 7px;
        color: white;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 14px;
        margin-left: 100px;
        margin-top: 50px;
      }
      .btn {
        padding: 10px 20px;
        background-color: #4c71db;
        border-radius: 7px;
        color: white;
        font-size: 14px;
      }
    }
  }
  height: auto !important;
  .top_box {
    padding: 30px 0 0 30px;
    .sty {
      margin: 30px 0;
    }
  }
}
</style>
